import { ChangeDetectionStrategy, Component, ViewEncapsulation, ChangeDetectorRef, forwardRef, Input, OnChanges, SimpleChanges, ElementRef} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PhxTag } from '../phx-tag.types';
import { defaultValues } from '../phx-tag.component';
import mixinDisabled from '../../../mixins/disabled';
import { Cross } from '../../icon/icon-map';

const baseMixin = mixinDisabled(
  class {
    constructor() {}
  }
);

@Component({
  selector: 'phx-tag-display',
  styleUrls: ['./phx-tag-display.component.scss'],
  templateUrl: './phx-tag-display.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: [
    'disabled'
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhxTagDisplayComponent),
      multi: true
    }
  ],
  host: {
    class: 'phx-tag-display',
    '[class.phx-disabled]': 'disabled',
  },
})
export class PhxTagDisplayComponent extends baseMixin implements ControlValueAccessor, OnChanges {
  @Input() public phxPlaceholder: string;

  public selectedTags: PhxTag[] = [];
  public disabled: boolean = false;
  public readonly phxTagDefaultValues: Omit<PhxTag, "label"> = {
    size: defaultValues.size,
    tagType: defaultValues.tagType,
    contrast: defaultValues.contrast,
    suffixIcon: Cross,
    disabled: defaultValues.disabled,
  };

  public onChange = (val) => {};
  public onTouched = () => {};

  constructor(
    private _cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled) {
      this._cdr.detectChanges();
    }
  }

  writeValue(tags: PhxTag[]): void {
    this.selectedTags = tags;
    this._cdr.markForCheck();
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public removeTag(index: number): void {
    this.selectedTags.splice(index, 1);
    this.onChange(this.selectedTags);
    this.onTouched();
  }
}

